const styles = theme => ({
  statusCounterWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    padding: '0 6px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  statusCounterItem: {
    display: 'flex',
    padding: '3px 4px',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    height: '20px',
    width: '20px',
    fontSize: '12px',
    fontWeight: 400,
  },
  statusCounterItemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    padding: '0 6px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  multilineTooltip: {
    maxWidth: 150,
    whiteSpace: 'normal',
  },
  effectiveMode: {
    backgroundColor: theme.palette.tag.operation,
    color: theme.palette.common.white,
  },
  operationalStopMode: {
    backgroundColor: theme.palette.tag.operationStop,
    color: theme.palette.common.white,
  },
  maintenanceMode: {
    backgroundColor: theme.palette.tag.maintenance,
    color: theme.palette.common.white,
  },
});

export default styles;
